import { getTaskGroupKeyDate, getTaskTitleDate } from '../../../../shared/lib';
import { TaskInList, TaskInListDto } from '../../../../shared/model/tasks/types';
import { groupDataSettings, TaskGroups } from '../config';
import { TaskGroupSettings } from '../types';

export const getTask = (task: TaskInListDto): TaskInList => {
  return {
    date: task.date,
    id: task.task_id,
    name: task.task_name,
    status: task.task_status,
    textDate: getTaskTitleDate(task.date),
    type: task.task_type,
    viewed: task.task_viewed,
  };
};

export const getTaskGroupSettings = (groupId?: string): TaskGroupSettings => {
  const values: TaskGroupSettings = {
    property: '',
    dateLength: undefined,
  };

  if (groupId === TaskGroups.Day || groupId === TaskGroups.Year || groupId === TaskGroups.Month) {
    values.property = 'date';
    values.dateLength = groupDataSettings[groupId];
  }

  if (groupId === TaskGroups.Status) {
    values.property = 'task_status';
  }

  if (groupId === TaskGroups.Type) {
    values.property = 'task_type';
  }

  return values;
};

export const isDayOrMonthGroup = (groupId?: string): boolean => {
  return groupId === TaskGroups.Month || groupId === TaskGroups.Day;
};

export const getTaskGroupKey = (
  task: TaskInListDto,
  property: Exclude<TaskGroupSettings['property'], ''>,
  dateLength?: number
): string => {
  const value: string = property === 'date' ? getTaskGroupKeyDate(task[property]) : task[property];

  return value.slice(0, dateLength);
};
